import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '@mui/material/Tooltip';
import { SxProps } from '@mui/system';
import { useGetUserMeQuery } from '../../services/entities/impl/blfApi/endpoints/users';
import { hasAuthorizedRole } from '../commonUtils';

interface Props {
  label: string;
  checked: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  authorizedRoles?: string[];
  sx?: SxProps;
  id?: string; // useful for formik forms
  name?: string; // useful for formik forms
}

const CheckboxAndLabel: React.FC<Props> = ({
  label,
  checked,
  handleChange,
  authorizedRoles = [],
  sx = {},
  id,
  name,
}) => {
  const { data: user } = useGetUserMeQuery();
  const enforceAuthorization = authorizedRoles.length > 0;

  let isAuthorized = true;
  if (enforceAuthorization) {
    isAuthorized = hasAuthorizedRole(authorizedRoles, user);
  }

  return (
    <Tooltip title={!isAuthorized ? 'Not authorized' : ''} placement='bottom'>
      <FormControlLabel
        id={id}
        name={name}
        control={<Checkbox checked={checked} onChange={handleChange} />}
        label={label}
        sx={{ ...sx, m: 0, whiteSpace: 'nowrap' }}
        disabled={!isAuthorized}
      />
    </Tooltip>
  );
};

export default CheckboxAndLabel;
